// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"controller_BuildControl__kcc5H","Label":"controller_Label__KcEoM","Less":"controller_Less__29k1K","More":"controller_More__Us8lW"};